export const RESET = 'reset';
export const SET_MOVIES = 'setMovies';
export const SET_SEARCH_MOVIES = 'setSearchMovies';
export const SET_CATEGORIES = 'setCategories';
export const SET_CURRENT_MOVIE = 'setCurrentMovie';
export const SET_CURRENT_SERIE = 'setCurrentSerie';
export const SET_CURRENT_TRAILER = 'setCurrentTrailer';
export const SET_SERIES = 'setSeries'
export const SET_Y_OFFSET = 'setPageYOffset';